import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import routes from './routes'
import Loading from './components/loading'
import './App.less'

class App extends Component {
  render () {
    return (
      <div className="app">
        <section className="content">
          <Switch>
            {routes.map((route, i) => (
              <Route {...route} key={i} />
            ))}
          </Switch>
        </section>

        <Loading />
      </div>
    )
  }
}

export default App
